module.exports = __webpack_public_path__ + "static/img/pic7.04cad02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/pic7.jpg
// module id = 9Bkp
// module chunks = 0